export const generatePassword = (length = 10): string => {
	const upperCaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const lowerCaseChars = "abcdefghijklmnopqrstuvwxyz";
	const numbers = "0123456789";
	const specialChars = "!@#$%^&*()_+[]{}|;:,.<>?";

	// 必須条件から各1文字を選択
	const upperCase = upperCaseChars[Math.floor(Math.random() * upperCaseChars.length)];
	const lowerCase = lowerCaseChars[Math.floor(Math.random() * lowerCaseChars.length)];
	const number = numbers[Math.floor(Math.random() * numbers.length)];
	const specialChar = specialChars[Math.floor(Math.random() * specialChars.length)];

	const allChars = upperCaseChars + lowerCaseChars + numbers + specialChars;
	const remainingLength = length - 4;
	const remainingChars = Array.from(
		{ length: remainingLength },
		() => allChars[Math.floor(Math.random() * allChars.length)],
	).join("");

	const password = [upperCase, lowerCase, number, specialChar, ...remainingChars]
		.sort(() => Math.random() - 0.5)
		.join("");

	return password;
};
